module.exports = __webpack_public_path__ + "img/type10.2d7e5f4a.png";